/**
 * File: bunny_frames.ts
 *
 * The two frames of the jumping ASCII bunny loader, shared by the Vue wrapper
 * (components/bunnyLoader.vue) and the imperative full-screen router loader
 * (components/jsComponents.ts) so the two can never drift apart.
 *
 * Plain ASCII on purpose. This replaced a ₍ᐢ•⩊•ᐢ₎ kaomoji whose seven
 * characters spanned four Unicode blocks, so the face resolved to a different
 * font — and a different shape, width and baseline — on every platform.
 */
export const BUNNY_FRAME_A = `  (\\(\\
  ( - -)
 c(")(")`;

export const BUNNY_FRAME_B = `  /)/)
 ( . .)
c(")(")`;
